import type { SemanticModel, SemanticModelInput } from '@aibi/contracts';
import { validateSemanticModel } from '@aibi/semantic-model';
import { AppError, err, ok, type Result } from '@aibi/shared';

export interface SemanticModelSummary {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  /** `true` si el modelo es de demostracion (resultados sinteticos). */
  readonly demo?: boolean;
}

/**
 * Puerto de acceso a los Semantic Models disponibles para analizar: el catalogo en memoria
 * con modelos demo o el combinado con los modelos publicados en el servidor.
 */
export interface SemanticModelCatalog {
  list(): Promise<Result<readonly SemanticModelSummary[], AppError>>;
  load(modelId: string): Promise<Result<SemanticModel, AppError>>;
  /** Error del origen remoto en el ultimo listado (`null` si respondio o no hay origen remoto). */
  unavailable?(): AppError | null;
}

/** Catalogo en memoria; cada modelo se valida (contrato + integridad) al cargarse. */
export function createInMemoryModelCatalog(
  models: readonly SemanticModelInput[],
): SemanticModelCatalog {
  return {
    list: () =>
      Promise.resolve(
        ok(
          models.map((model) => ({
            id: model.id,
            name: model.name,
            description: model.description ?? null,
          })),
        ),
      ),
    load: (modelId) => {
      const model = models.find((candidate) => candidate.id === modelId);
      if (!model) {
        return Promise.resolve(err(new AppError('NOT_FOUND', `No existe el modelo "${modelId}".`)));
      }
      return Promise.resolve(validateSemanticModel(model));
    },
  };
}
